module.exports = __webpack_public_path__ + "static/media/30x30-16.5faa269b.png";